import GenericMarketContent from './_generic-market-content.js'
import GameLineMarketContent from './_game-line-market-content.js'
import BaseEventCard from './_base-event-card.js'
import FlexPane from './_flex-pane.js'
import SportIcons from './_sport-icons.js'
import Image from './_image.js'
import AbsolutePane from './_absolute-pane.js'
import EventTimingStatus from './_event-timing-status.js'
import EventListItemDetails from './_event-list-item-details.js'
import Text from './_text.js'

export default {
  name: 'MatchEventCard',
  values: {
    showSportIcon: true,
    showBackgroundSportImage: true,
    noBackgroundImageSports: [
    ],
    genericMarketContent: {
      configSet: GenericMarketContent,
      configValues: {
        container: {
          style: {
            padding: '0 8px',
          },
        },
        market: {
          showUnavailablePlaceholder: true,
          selectionButton: {
            view: {
              layoutDirection: 'vertical',
              nameDisplay: 'show short',
            },
          },
        },
        layoutDescriptors: {
          default: {
            selectionTypes: [
              'X',
            ],
          },
        },
      },
    },
    gameLineMarketContent: {
      configSet: GameLineMarketContent,
      configValues: {
        showScoreboard: true,
        participants: {
          showTeamLogo: true,
          showShortName: true,
          container: {
            style: {
              padding: '20px 0 0 0',
            },
          },
        },
        scoreboard: {
          allowAmericanLayout: false,
          padding: '20px 0 0 0',
        },
        container: {
          itemSpacing: '8px',
          style: {
            padding: '0 8px',
          },
        },
        marketsContainer: {
          itemSpacing: '2px',
          style: {
            flexBasis: 'auto',
          },
        },
        market: {
          headerContainer: {
            style: {
              height: '18px',
            },
          },
          headerLabel: {
            ellipsisOnLineNumber: 1,
          },
          selectionButton: {
            view: {
              height: '44px',
              width: '56px',
              layoutDirection: 'vertical',
            },
          },
        },
      },
    },
    eventCard: {
      configSet: BaseEventCard,
      configValues: {
        container: {
          style: {
            padding: '8px 0',
            justifyContent: 'space-between',
          },
        },
        clickableArea: {
          style: {
            base: {
              justifyContent: 'start',
            },
          },
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          padding: '0 8px 8px 8px',
          justifyContent: 'space-between',
        },
      },
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    sportIcon: {
      configSet: Image,
      configValues: {
        style: {
          width: '12px',
          maxHeight: '16px',
          alignSelf: 'stretch',
        },
      },
    },
    backgroundImageWrapper: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          top: '8px',
          right: '8px',
          overflow: 'hidden',
        },
      },
    },
    backgroundSportImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-end',
          padding: '0 0 8px 8px',
        },
      },
    },
    usBackgroundImageWrapper: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          bottom: '8px',
          left: '8px',
          overflow: 'hidden',
        },
      },
    },
    usBackgroundSportImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-start',
          padding: '0 22px 0 0',
        },
      },
    },
    headerTime: {
      configSet: EventTimingStatus,
      configValues: {
        container: {
          style: {
            base: {
              flexDirection: 'row-reverse',
              flexShrink: 0,
            },
          },
        },
      },
    },
    participantsAndMarketsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexGrow: 0,
        },
      },
    },
    eventItemDetails: {
      configSet: EventListItemDetails,
      configValues: {
        container: {
          style: {
            minHeight: '36px',
            justifyContent: 'normal',
            padding: '0 8px 8px',
          },
        },
        scoreboard: {
          showSegmentIndicators: false,
        },
        participants: {
          showTeamLogo: true,
          showStartingPitcher: false,
          container: {
            style: {
              justifyContent: 'start',
            },
          },
          textWrapper: {
            style: {
              padding: '0 0 4px 0',
            },
          },
        },
        participantsAndScoreContainer: {
          style: {
            flexGrow: 0,
          },
        },
      },
    },
    marketTitle: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          padding: '0 8px 2px 8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
